import { Link } from "react-router-dom";
import type { Transaction } from "../types";
import { formatDate, formatMoney } from "../lib/format";
import { SourceBadge } from "./SourceBadge";
import { StatusBadge } from "./StatusBadge";

export function TransactionCard({
  txn,
  to,
  state,
}: {
  txn: Transaction;
  to?: string;
  state?: unknown;
}) {
  const content = (
    <>
      <div className="row between">
        <div className="merchant">{txn.merchant_name}</div>
        <div className="row" style={{ gap: "0.35rem", flexShrink: 0 }}>
          <SourceBadge source={txn.import_source} />
          <StatusBadge status={txn.status} />
        </div>
      </div>
      <div className="row between" style={{ marginTop: "0.45rem" }}>
        <span className="muted">
          {formatDate(txn.transaction_date)}
          {txn.card_last4
            ? ` · ••${txn.card_last4}`
            : txn.import_source === "boekhoudgemak"
              ? " · Bank"
              : ""}
        </span>
        <span className="amount" style={{ textAlign: "right" }}>
          {formatMoney(txn.amount, txn.currency)}
          {txn.original_amount &&
            txn.original_currency &&
            (txn.original_currency !== txn.currency ||
              txn.original_amount !== txn.amount) && (
              <div className="muted" style={{ fontSize: "0.75rem", fontWeight: 500 }}>
                {formatMoney(txn.original_amount, txn.original_currency)} original
              </div>
            )}
        </span>
      </div>
    </>
  );

  if (to) {
    return (
      <Link to={to} state={state} className="txn-card">
        {content}
      </Link>
    );
  }

  return <div className="txn-card">{content}</div>;
}
